import {Fragment, useContext, useEffect, useState} from 'react'
import {Stack} from 'react-bootstrap'
import {useLocation, useNavigate} from 'react-router-dom'
import {KTCardBody, KTIcon} from '../../../../../_metronic/helpers'
import {formatDateToDMY} from '../../../../helpers/dateFunctions'
import {getAllPartnersPag} from '../../../../services/colaboradores'
import {fetchMenuActionsByRole, fetchSubMenuByUrl} from '../../../../services/menu'
import {changeStatusFicha} from '../../../../services/registroFicha'
import {showMessage} from '../../../../shared/Alerts'
import {ModernPagination} from '../../../../shared/ModernPagination'
import SortableTableHeader from '../../../../shared/SortableTableHeader'
import {UsersListLoading} from '../../../apps/user-management/users-list/components/loading/UsersListLoading'
import {useAuth2} from '../../../authv2/Auth2Provider'
import {PartnerContext} from '../PartnerContexts'

const HistorialDocumentsTable = () => {
  const [sortBy, setSortBy] = useState({columnName: '', sortDirection: ''})
  const [isLoading, setLoadingStatus] = useState(false)
  const [totalPages, setTotalPages] = useState(1)
  const [lista, setLista] = useState<any[]>([])

  const {
    activeOnly,
    state,
    searchTerm,
    currentPage,
    setCurrentPage,
    id_process,
    setId_Process,
    entryDateFrom,
    entryDateTo,
    openObservacionModal,
    unidad,
  } = useContext(PartnerContext)

  const navigate = useNavigate()

  const location = useLocation()
  const {selectedRole} = useAuth2()
  const [permissions, setPermissions] = useState<string[]>([])

  useEffect(() => {
    const fetchPermissions = async () => {
      const response = await fetchMenuActionsByRole(selectedRole)
      if (response.success) {
        const currentPath = location.pathname
        const subMenuResponse = await fetchSubMenuByUrl(currentPath)
        if (subMenuResponse.success) {
          const subMenuId = subMenuResponse.data.id_hijo
          const permissionsForSubMenu =
            response.data.find((item: any) => item.subMenuId === subMenuId)?.acciones || []
          setPermissions(permissionsForSubMenu)
        }
      }
    }

    fetchPermissions()
  }, [selectedRole])

  useEffect(() => {
    if (id_process !== '') {
      setLoadingStatus(true)
      refetchData({
        activeOnly: activeOnly,
        sheetStates: state,
        searchQuery: searchTerm,
        entryDateFrom: entryDateFrom,
        entryDateTo: entryDateTo,
        id_process: id_process,
        sortBy: sortBy.columnName,
        sortOrder: sortBy.sortDirection,
        unidad: unidad,
      })
    }
  }, [
    activeOnly,
    state,
    entryDateFrom,
    entryDateTo,
    currentPage,
    id_process,
    sortBy,
    unidad,
    searchTerm,
  ])

  const sortData = (data: any[], sortBy: string, sortOrder: 'asc' | 'desc'): any[] => {
    return data.sort((a, b) => {
      if (sortOrder === 'asc') {
        return a[sortBy] - b[sortBy]
      } else {
        return b[sortBy] - a[sortBy]
      }
    })
  }

  const refetchData = (options: any) => {
    setLoadingStatus(true)
    getAllPartnersPag(currentPage, 10, options)
      .then((response: any) => {
        if (response.success) {
          console.log(response.length)
          setLoadingStatus(false)
          const auxTotalPage = response.length ? Math.ceil(response.length / 10) : totalPages
          setTotalPages(
            response.totalPages ? (response.totalPages === 0 ? 1 : response.totalPages) : 1
          )

          let sortedData = response?.data

          if (['totalPending', 'totalSigned', 'totalRejected'].includes(options.sortBy)) {
            console.log('options' + options.sortBy)
            sortedData = sortData(response?.data, options.sortBy, options.sortOrder)
            console.log('SORTED DATA', JSON.stringify(sortedData, null, 2))
          }

          setLista(sortedData)
        } else {
          console.log(response)
        }
      })
      .catch((error: any) => {
        console.log(error)
      })
  }

  const handlePageChange = (page: number) => {
    setCurrentPage(page)
  }

  const changeStatusRegistroFicha = (id: string, estado: string) => {
    changeStatusFicha(id, {estado})
      .then((response) => {
        if (response.success) {
          showMessage('success', '¡Buen trabajo!', response.message)
        } else {
          showMessage('error', 'Hubo un error', response.error)
        }
        refetchData({
          activeOnly: activeOnly,
          sheetStates: state,
          searchQuery: searchTerm,
          entryDateFrom: entryDateFrom,
          entryDateTo: entryDateTo,
          id_process: id_process,
        })
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const handleView = (id: any) => {
    navigate(`/seguimiento/historialdocumentos/detalle/${id}`)
  }

  const handleSort = (columnName: string, sortDirection: string) => {
    console.log('Sorting column:', columnName, 'Direction:', sortDirection)
    setSortBy({columnName, sortDirection})
    console.log('SortBy state updated:', sortBy)
  }

  return (
    <>
      <KTCardBody className='py-4'>
        <div className='table-responsive'>
          <table className='table align-middle table-row-bordered fs-6 table-hover'>
            <thead>
              <tr className='text-start fw-bolder fs-7 text-uppercase gs-0 bg-primary text-white'>
                <th className='text-start p-3'>Unidad</th>
                {/* <th className=''>Nro Solicitud</th> */}
                <th className=''>DNI</th>
                <SortableTableHeader
                  label='Nombres y Apellidos'
                  columnName='nombres'
                  handleSort={handleSort}
                  activeColumn={sortBy.columnName}
                  labelStyle={{color: '#ffffff'}}
                />
                <SortableTableHeader
                  label='Cargo'
                  columnName='cargo'
                  handleSort={handleSort}
                  activeColumn={sortBy.columnName}
                  labelStyle={{color: '#ffffff'}}
                />
                <SortableTableHeader
                  label='Fec. Ingreso'
                  columnName='fechaIngreso'
                  handleSort={handleSort}
                  activeColumn={sortBy.columnName}
                  labelStyle={{color: '#ffffff'}}
                />
                <SortableTableHeader
                  label='Doc. Firmados'
                  columnName='totalSigned'
                  handleSort={handleSort}
                  activeColumn={sortBy.columnName}
                  labelStyle={{color: '#ffffff'}}
                />
                <SortableTableHeader
                  label='Doc. Pend.'
                  columnName='totalPending'
                  handleSort={handleSort}
                  activeColumn={sortBy.columnName}
                  labelStyle={{color: '#ffffff'}}
                />
                <SortableTableHeader
                  label='Doc. Obs'
                  columnName='totalRejected'
                  handleSort={handleSort}
                  activeColumn={sortBy.columnName}
                  labelStyle={{color: '#ffffff'}}
                />
                <th className='text-end p-3' style={{paddingBlock: '5px', paddingRight: '5px'}}>
                  Opciones
                </th>
              </tr>
            </thead>
            <tbody className='text-gray-600 fw-bold'>
              {lista.length > 0 ? (
                lista?.map((item: any, index: any) => (
                  <Fragment key={item._id}>
                    <tr>
                      <td className='text-start min-w-200px p-2'>{item.unidad}</td>
                      {/* <td> Sol{item._id.slice(0, 3)}...{item._id.slice(-3)} </td> */}
                      <td>{item.dni}</td>
                      <td className='text-start min-w-300px p-1'>
                        {item.nombres} {item.apellidos}
                      </td>
                      <td className='text-start min-w-200px p-1'>{item.cargo}</td>
                      <td className='text-start min-w-150px p-1'>
                        {formatDateToDMY(item.fechaIngreso)}
                      </td>
                      <td className='text-center min-w-150px p-1'>{item.totalSigned}</td>
                      <td className='text-center min-w-150px p-1'>{item.totalPending}</td>
                      <td className='text-center min-w-150px p-1'>{item.totalRejected}</td>
                      <td className='text-end d-flex align-self-end justify-content-end p-1'>
                        <Stack direction='horizontal' gap={1}>
                          {permissions.includes('Ver Detalle') && (
                            <button
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                              title='ver detalle'
                              onClick={() => handleView(item.idUsuario)}
                            >
                              <KTIcon iconName='eye' className='fs-3' />
                            </button>
                          )}
                        </Stack>
                      </td>
                    </tr>
                    {/* {item._id === selecto ? (
                      <ListaSecciones
                        id={selecto}
                        mnuevo={mnuevo}
                        setMnuevo={setMnuevo}
                        nuevo={nuevo}
                      />
                    ) : null} */}
                  </Fragment>
                ))
              ) : (
                <tr>
                  <td colSpan={5}>
                    <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                      No matching records found
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {/* <UsersListPagination /> */}
        <ModernPagination
          totalPages={totalPages}
          currentPage={currentPage}
          isLoading={isLoading}
          onPageChange={handlePageChange}
        />
        {isLoading && <UsersListLoading />}
      </KTCardBody>
    </>
  )
}

export {HistorialDocumentsTable}
